import { ref } from 'vue'
import api from './api'

export const adminBrand = ref({})

export async function refreshAdminBrand() {
  const data = await api.call('brand')
  adminBrand.value = data.brand || {}
  return data
}

export function clearAdminBrand() {
  adminBrand.value = {}
}
